"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyInfo = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const Wrap = (0, app_1.styled)(ui_1.Stack) `
  align-items: center;
  justify-content: center;
  color: ${(theme) => theme.colors.secondary};
`;
const Block = app_1.styled.div `
  width: 6.25rem;
  height: 6.25rem;
  border: 1px dashed ${(theme) => theme.stroke};
  ${(theme) => theme.flexCenter};
  border-radius: ${(theme) => theme.radius.small};
  color: ${(theme) => theme.stroke};
  margin-bottom: ${(theme) => theme.spacing.extraSmall};
`;
const Title = (0, app_1.styled)(app_1.Text) `
  font-size: 1.5rem !important;
  line-height: 100%;
  font-weight: 400;
  font-family: ${(theme) => theme.secondaryFont};
  text-align: center;
`;
const Description = app_1.styled.span `
  font-size: 1rem;
  line-height: 1.5rem;
  text-align: center;
`;
const Margin = app_1.styled.div `
  padding: ${(theme) => theme.spacing.extraLarge} 0;
`;
function SvgBlock({ svg: SvgElement }) {
    return ((0, jsx_runtime_1.jsx)(Block, { children: (0, jsx_runtime_1.jsx)(SvgElement, {}) }));
}
function EmptyInfo({ description, svg, title, }) {
    return ((0, jsx_runtime_1.jsxs)(Wrap, Object.assign({ kind: "vertical", spacing: "extraSmall" }, { children: [(0, jsx_runtime_1.jsx)(SvgBlock, { svg: svg }), (0, jsx_runtime_1.jsx)(Title, Object.assign({ tag: "h2" }, { children: title })), description ? (0, jsx_runtime_1.jsx)(Description, { children: description }) : null] })));
}
exports.EmptyInfo = EmptyInfo;
EmptyInfo.Margin = Margin;
